import { motion } from 'framer-motion';
import { ShieldCheck, Zap, CheckCircle2, UserCheck, BadgePercent, Briefcase } from 'lucide-react';
import { REASONS } from '../data/site';
import Reveal, { ChapterLabel, EASE } from './Reveal';

const ICONS = { ShieldCheck, Zap, CheckCircle2, UserCheck, BadgePercent, Briefcase };

export default function WhyUs() {
  return (
    <section data-testid="why-us-section" className="relative overflow-hidden bg-navy py-24 md:py-32">
      <div className="fm-grid-bg pointer-events-none absolute inset-0 opacity-60" />
      <div className="fm-glow pointer-events-none absolute -right-40 top-0 h-[500px] w-[500px] opacity-60" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <ChapterLabel index="03" title="Warum F&M" dark />
        <div className="mt-8 max-w-3xl">
          <Reveal delay={0.1}>
            <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
              Sechs Gründe, warum Kunden <span className="text-brand">uns vertrauen</span>.
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((r, i) => {
            const Icon = ICONS[r.icon];
            return (
              <motion.div
                key={r.title}
                data-testid={`why-card-${i + 1}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: EASE }}
                className="group rounded-3xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur transition-colors duration-500 hover:border-brand/50 hover:bg-white/[0.07]"
              >
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand/15 text-brand transition-all duration-500 group-hover:bg-brand group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-white">{r.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{r.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
